document.addEventListener('DOMContentLoaded', function () {

    const tabs = document.querySelectorAll('.collection-tab');
    const contents = document.querySelectorAll('.collection-content');

    tabs.forEach(function(tab){

        tab.addEventListener('click', function(){

            const target = this.dataset.tab;

            tabs.forEach(function(item){
                item.classList.remove('active');
            });

            contents.forEach(function(item){
                item.classList.remove('active');
            });

            this.classList.add('active');

            document
                .getElementById(target)
                .classList
                .add('active');

        });

    });

});